import { render, staticRenderFns } from "./Waybill.vue?vue&type=template&id=96b45446&scoped=true&"
import script from "./Waybill.vue?vue&type=script&lang=js&"
export * from "./Waybill.vue?vue&type=script&lang=js&"
import style0 from "./Waybill.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Waybill.vue?vue&type=style&index=1&id=96b45446&lang=scss&scoped=true&"
import style2 from "./Waybill.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b45446",
  null
  
)

export default component.exports